import Marquee from "react-fast-marquee";

const ITEMS = [
    "MODULAR WORKSTATIONS",
    "EXECUTIVE DESKS",
    "ERGONOMIC SEATING",
    "CONFERENCE SYSTEMS",
    "STORAGE & FILING",
    "RECEPTION & BREAKOUT",
];

export const EditorialMarquee = () => (
    <section data-testid="editorial-marquee" className="py-10 md:py-14 bg-white border-y border-line overflow-hidden">
        <Marquee speed={35} gradient={false} pauseOnHover>
            {ITEMS.map((t) => (
                <span key={t} className="flex items-center">
                    <span className="mx-6 md:mx-10 font-heading font-extrabold tracking-tight text-4xl md:text-6xl text-outline-navy whitespace-nowrap">
                        {t}
                    </span>
                    <span className="text-gold text-2xl md:text-4xl">·</span>
                </span>
            ))}
        </Marquee>
    </section>
);
